<template>
             <div style="width: 100%;padding: 2rem 0rem">
                <Steps :model="items" :readonly="false" aria-label="Form Steps" />
            </div>
   
</template>  
<script>


export default {
    props: ["stepId","creator","sourcer","manager","addMember"],
    components: {

    },
    data() {
        return {
            items: [
                { label: '申請', to: '', class: 'green_item', style: 'font-weight:bolder;font-size:large' },
                { label: 'Sourcer', to: '', class: 'white_item', style: 'font-weight:bolder;font-size:large' },
                { label: '會簽', to: '', class: 'white_item', style: 'font-weight:bolder;font-size:large' },
                { label: '主管', to: '', class: 'white_item', style: 'font-weight:bolder;font-size:large' }
            ],
         
        }
    },
    Service: null,
    EFormService: null,
    created() {
        this.ShowStep();
       
    },
    watch: {
        stepId: function () {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.ShowStep();
            },
            creator: function (newVal) {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.items[0].label = '申請:<br/>'+newVal
            },
            sourcer: function (newVal) {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.items[1].label = 'Sourcer:\n'+newVal
            },
            manager: function (newVal) {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.items[3].label = '主管:'+newVal
            },
            addMember: function (newVal) {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.items[2].label = '會簽:'+newVal
            },
          },
    computed: {
      
    },
   methods: {
         
            ShowStep() {
                //sourcer
                if (this.stepId == 1) {
                    this.items[1].class = 'yellow_item'
                    this.items[2].class = 'white_item'
                    this.items[3].class = 'white_item'
                }
                //會簽            
                if (this.stepId == 2) {
                    this.items[1].class = 'green_item'
                    this.items[2].class = 'yellow_item'
                    this.items[3].class = 'white_item'
                }
                //主管
                if (this.stepId == 3) {
                    this.items[1].class = 'green_item'
                    this.items[2].class = 'green_item'
                    this.items[3].class = 'yellow_item'
                }
            },
        }
    }
</script>
  

<style scoped>
.flowClass {
    display: flex;
    padding-bottom: 1rem
}

.flowClass span {
    font-size: 22px;
    font-weight: bold;
}

.flowClass label {
    font-size: 22px;
}

.yellow_item .p-steps-number {
    background: yellow !important;
    color: yellow !important;
}

.yellow_item .p-menuitem-link {
    background: none !important;
}

.green_item .p-steps-number {
    background: green !important;
    color: green !important;
}

.green_item .p-menuitem-link {
    background: none !important;
}

.white_item .p-steps-number {
    color: white !important;
}

.white_item .p-menuitem-link {
    background: none !important;
}
</style>